import { useSelector } from 'react-redux'
import { featureValueSelector } from '../selectors'
import { FeatureName, FeatureValues } from '../types'

export function useFeature<K extends FeatureName>(featureName: K): FeatureValues[K] {
  return useSelector(featureValueSelector(featureName))
}
